var map = {
	"./FooterExtensions": 86336,
	"./FooterExtensions.ts": 86336,
	"./HeaderExtensions": 84358,
	"./HeaderExtensions.ts": 84358,
	"./ReadMe": 42275,
	"./SignInPageExtensions": 48634,
	"./SignInPageExtensions.ts": 48634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88172;